import useFlowTranslate from 'FlowBuilder/hooks/useFlowTranslate'

export default function ProgressBar({ currentPage, totalPages }) {
  const safeTotalPages = Math.max(currentPage, totalPages);
  const rawPercentage = safeTotalPages > 0 ? ((currentPage - 1) / safeTotalPages) * 100 : 0;
  const percentage = Math.min(100, Math.max(0, Math.round(rawPercentage)));
  const { fallback: { progressPageText, progressCompletedText } } = useFlowTranslate()

  const pageText = progressPageText
    .replace(/{{\s*current\s*}}/g, currentPage.toString())
    .replace(/{{\s*total\s*}}/g, safeTotalPages.toString())

  const completedText = progressCompletedText
    .replace(/{{\s*percentage\s*}}/g, percentage.toString())

  return (
    <div className="progress-container">
      <div className="progress">
        <div className="progress-bar" style={{ width: `${percentage}%` }} />
      </div>
      <p className="progress-text">
        <strong>{pageText}</strong> {completedText}
      </p>
    </div>
  );
}
